import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Wrapper = styled.section`
	padding: 96px 0;
`;

export const Grid = styled(GridWrapper)`
	grid-template-columns: 100%;

	${minWidth('desktop')} {
		grid-template-columns: 50% 50%;
	}
`;

export const Heading = styled.h2`
	color: ${palette('gray7')};
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 20px;
`;

export const BodyText = styled.p`
	color: ${palette('gray7')};
	margin-bottom: 52px;

	& a {
		text-decoration: underline;
	}
`;

export const PDF = styled(BodyText)`
	margin-top: 32px;
`;

export const PlayerContainer = styled.div<{ isMultiple: boolean }>`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
`;

export const ContentHeading = styled.h3`
	color: ${palette('gray7')};
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 12px;
`;
